import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { forgetPasswordSchema } from "../../Schema/authSchema";
import { useMutation } from "react-query";
import { recoverPassword } from "../../Services/Auth";
import { Error, Success } from "../../Components/Modal";
import Button from "../../Components/Button";
import "../../styles/PremiumLogin.css";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(forgetPasswordSchema),
  });

  const { mutate, isLoading } = useMutation((data) => recoverPassword(data), {
    retry: false,
    onSuccess: (res) => {
      // console.log("Recover: ", res.data);
      Success("Forgot Password", res.data?.message);
      navigate("/verification", { replace: true });
    },
    onError: (err) => {
      // console.log("recoverPassword Err: ", err);
      Error(err.response.data?.message);
    },
  });

  const submit = (data) => {
    // console.log(data, "data");
    localStorage.setItem("email", data?.email);
    mutate(data);
  };

  console.log(errors);

  return (
    <section className="loginPage">
      <div className="container-fluid p-0">
        <div className="row g-0 align-items-center">
          <div className="col-lg-6 px-4 loginBgLeft d-none d-lg-flex flex-column justify-content-center">
            <div className="loginBgLeftPattern" style={{ backgroundImage: "url('/images/loginLeftContentBG.png')" }} />
            <div className="loginLeftContent">
              <img
                src="images/loginLogo.png"
                alt="MUVRRS Logo"
                className="img-fluid loginLogo"
              />
              <p className="loginLeftTagline">
                Recover your access. <strong>Safe and secure.</strong>
              </p>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 loginBgRight">
            <div className="loginCard">
              <div className="text-center d-block d-lg-none mb-4">
                <img
                  src="images/loginLogo.png"
                  alt="MUVRRS Logo"
                  className="loginLogo img-fluid"
                />
              </div>
              <div className="formBox">
                <div className="formHeading mb-4">
                  <h2>Password Recovery</h2>
                  <p>Please enter your email to receive a recovery code</p>
                </div>
                <form
                  className="py-2"
                  onSubmit={handleSubmit(submit)}
                >
                  <div className="form-field">
                    <label htmlFor="email" className="siteLabel">
                      Email<span className="text-danger">*</span>
                    </label>
                    <div className="input-icon-wrapper">
                      <i className="fas fa-envelope input-icon-left" />
                      <input
                        type="email"
                        className="siteInput"
                        placeholder="Enter Email Address"
                        id="email"
                        {...register("email")}
                      />
                    </div>
                    {errors?.email && (
                      <span className="text-danger">
                        {errors?.email?.message}
                      </span>
                    )}
                  </div>
                  <div className="form-field mt-4 text-center">
                    <Button
                      type="submit"
                      className="siteBtn w-100 mb-3"
                      loading={isLoading}
                    >
                      Continue
                    </Button>
                    <Link
                      to="/superadmin"
                      className="siteBtn2 w-100 mb-3"
                      onClick={() => localStorage.removeItem("email")}
                    >
                      Back To Sign In
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
